import { render, staticRenderFns } from "./MyBeansDetails.vue?vue&type=template&id=59ec0f42&scoped=true"
import script from "./MyBeansDetails.vue?vue&type=script&lang=js"
export * from "./MyBeansDetails.vue?vue&type=script&lang=js"
import style0 from "./MyBeansDetails.vue?vue&type=style&index=0&id=59ec0f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec0f42",
  null
  
)

export default component.exports